<template>
 <!-- 其他险种管理 -->
  <div>
    <div v-show="Qtxzgl">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">其他险种管理</div>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:2%">
        <div style="height:40px"></div>
        <div style="display:inline-block;margin-left:10px">
          <span>保单名称 </span>
        <el-input v-model="condition.insurance_name" style="margin-left:10px;width:160px" placeholder="请输入保单名称"></el-input>
        </div>

        <div style="display:inline-block;margin-left:10px">
          <span>出险内容 </span>
          <el-select v-model="condition.dictionaries_id" style="margin-left:10px;width:160px" placeholder="请选择出险内容" clearable>
          <el-option
            v-for="item in cxList"
            :key="item.id"
            :label="item.data"
            :value="item.id">
          </el-option>
        </el-select>
        </div>

        <div style="display:inline-block;margin-left:10px">
          <span>承保公司 </span>
          <el-select v-model="condition.company_id" style="margin-left:10px;width:160px" placeholder="请选择承保公司" clearable>
            <el-option
                v-for="item in cbgsList"
                :key="item.id"
                :label="item.company_name"
                :value="item.id">
            </el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-left:10px">
            <span>生效日期 </span>
          <el-date-picker v-model="condition.create_time" type="date" style="margin-left:10px;width:160px" placeholder="请选择"></el-date-picker>
        </div>

        <div style="display:inline-block;margin-left:10px">
            <span>保单号</span>
          <el-input v-model="condition.policy_no" style="margin-left:10px;width:160px" placeholder="请输入保单号"></el-input>
        </div>


        <!-- 按钮 -->
        <div style="display:inline-block;margin-top:20px;float:right;margin-right:5%">
          <el-button type="goon" @click="Find">查询</el-button>
          <el-button type="goon" @click="Dell()">删除</el-button>
          <el-button type="addbtn" @click="add()">新增</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <div style="margin:5% 3% 0 3%">
        <el-table
          :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height:540px"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="insurance_name" align="center" label="保单名称"></el-table-column>
          <el-table-column prop="insure_name" align="center" label="投保内容"></el-table-column>
          <el-table-column prop="insure_account" align="center"  label="投保账户"></el-table-column>
          <el-table-column prop="company_name" align="center" label="承保公司"></el-table-column>
          <el-table-column prop="" align="center" label="生效起止时间" width=200>
            <template slot-scope="scope">
                {{scope.row.start_date}} ~ {{scope.row.end_date}}
            </template>
          </el-table-column>
          <el-table-column prop="policy_no" align="center" label="保单号"></el-table-column>
          <el-table-column prop="unit_price" align="center" label="单价"></el-table-column>
          <el-table-column prop="premium" align="center" label="保费"></el-table-column>
          <el-table-column prop="insured_amount" align="center" label="保额"></el-table-column>
          <el-table-column align="center" label="操作" width=100>
            <template slot-scope="scope">
              <img src="../../../assets/详情.png" @click="xiangqing(scope.row)">
              <img src="../../../assets/明细.png" @click="mingxi(scope.row)">
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-row style="margin-top: 10px; text-align: center;">
          <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
            layout=" prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-row>
      </div>
      
    </div>
    </div>
    <add ref="adds" v-show="showadd"></add>
    <edit ref="edits" v-show="showedit"></edit>
    <detailed ref="detaileds" v-show="showdetailed"></detailed>
  </div>
</template>

<script>
import axios from 'axios';
import add from './Qtxzgl_add.vue';
import edit from './Qtxzgl_edit.vue';
import detailed from './Qtxzgl_detailed.vue';
export default {
  components: {
    add:add,
    edit:edit,
    detailed:detailed,
  },
  data() {
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      cbgsList:[],
      cxList:[],
      tableData:[],
      //删除ids
      ids: [],
      ruleForm:{
        id:'',
        insurance_name:'',
        insure_name:'',
        insure_account:'',
        company_name:'',
        start_date:'',
        end_date:'',
        policy_no:'',
        unit_price:'',
        premium:'',
        insured_amount:'',
        plate_id:'',
        proportion:'',
        post_id:'',
        age_id:'',
        project_id:'',
        dictionaries_id:'',
        insure_account:'',
        company_id:'',
        company_contacts:'',
        company_telephone:'',
        remarks:'',
        spare1:'',
        spare2:'',
        insurance_url:'',
        enclosure_url:'',
        insurance_id:'',
      },
      condition:{
        id:'id',
        insurance_name:'',
        company_id:'',
        dictionaries_id:'',
        policy_no:'',
        create_time:'',
        insurance_id:'',
      },
      // 权限
      Qtxzgl:true,
      showadd:false,
      showedit:false,
      showdetailed:false,
      
    }
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
      this.ids = [];
      e.forEach(item => {
          this.ids.push(item.id);
      });
    },
    //分页
    handleCurrentChange(val) {
        this.page_num = val;
        this.Find();
    },
    // 返回
    Return(){
        this.showadd = false;
        this.showedit = false;
        this.showdetailed = false;
        this.Qtxzgl = true;
        this.Find();
        this.trash();
    },
    //查询
    async Find() {
        var url = '/OtherInsurance/selectAll';
        var record = {
            page_num: this.page_num,
            page_size: this.page_size,
            company_id:this.condition.company_id,
            dictionaries_id:this.condition.dictionaries_id,
            insurance_name:this.condition.insurance_name,
            policy_no:this.condition.policy_no,
            create_time:this.condition.create_time,
            insurance_id:this.condition.insurance_id,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.tableData = data.list;
                this.total = data.total;
            } else {
                this.$message.warning('请求失败！请稍后重试');
            }
        }
    },
    // 新增
    add(){
      this.Qtxzgl = false;
      this.showadd = true;
      this.$refs.adds.add;
      this.Find();
      this.trash();
    },
    // 操作详情
    xiangqing(e){
      this.Qtxzgl = false;
      this.showedit = true;
      this.$refs.edits.edit;
      this.ruleForm.insurance_name = e.insurance_name;
      this.ruleForm.insure_account = e.insure_account;
      this.ruleForm.insure_name = e.insure_name;
      this.ruleForm.policy_no = e.policy_no;
      this.ruleForm.company_name = e.company_name;
      this.ruleForm.id = e.id;
      this.ruleForm.start_date = e.start_date;
      this.ruleForm.end_date = e.end_date;
      this.ruleForm.policy_no = e.policy_no;
      this.ruleForm.insure_number = e.insure_number;
      this.ruleForm.unit_price = e.unit_price;
      this.ruleForm.premium = e.premium;
      this.ruleForm.plate_id = e.plate_id;
      this.ruleForm.insured_amount = e.insured_amount;
      this.ruleForm.proportion = e.proportion;
      this.ruleForm.post_id = e.post_id;
      this.ruleForm.age_id = e.age_id;
      this.ruleForm.project_id = e.project_id;
      this.ruleForm.dictionaries_id = e.dictionaries_id;
      this.ruleForm.remarks = e.remarks;
      this.ruleForm.company_contacts = e.company_contacts;
      this.ruleForm.company_telephone = e.company_telephone;
      this.ruleForm.spare1 = e.spare1;
      this.ruleForm.spare2 = e.spare2;
      this.ruleForm.insurance_url = e.insurance_url;
      this.ruleForm.enclosure_url = e.enclosure_url;
    },
    // 操作明细
    mingxi(e){
      this.Qtxzgl = false;
      this.showdetailed = true;
      this.ruleForm.insurance_id = e.id;
      this.ruleForm.insurance_name = e.insurance_name;
      this.ruleForm.policy_no = e.policy_no;
      this.$refs["detaileds"].Find();
    },
    //删除
    Dell(e) {
      var ids;
      if (e === null || e === '' || e === undefined) {
        if (this.ids === null || this.ids.length <= 0) {
          this.$message.warning('请先选择操作数据！');
          return false;
        }
        ids = this.ids;
      } else {
        ids = [e];
      }
      const url = this.$globals.http + 'OtherInsurance/del';
      axios
        .post(url, {
          ids: ids,
        })
        .then((response) => {
          var code = response.data.code;
          var data = response.data.data;

          if (code === '200') {
            this.$message.success(data);
            this.Find();
          } else {
            this.$message.warning('请求失败！请稍后重试');
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error('服务器未响应！请稍后重试');
        });
    },
     //清除数据
    trash() {
      this.ruleForm.id = '';
      this.ruleForm.plate_id = '';
      this.ruleForm.post_id = '';
      this.ruleForm.age_id = '';
      this.ruleForm.project_id = '';
      this.ruleForm.dictionaries_id = '';
      this.ruleForm.insurance_name = '';
      this.ruleForm.insured_amount = '';
      this.ruleForm.insure_account = '';
      this.ruleForm.remarks = '';
      this.ruleForm.proportion = '';
      this.ruleForm.start_date = '';
      this.ruleForm.end_date = '';
      this.ruleForm.company_id = '';
      this.ruleForm.unit_price = '';
      this.ruleForm.policy_no = '';
      this.ruleForm.premium = '';
      this.ruleForm.company_contacts = '';
      this.ruleForm.company_telephone = '';
      this.ruleForm.spare1 = '';
      this.ruleForm.spare2 = '';
      this.ruleForm.insurance_url = '';
      this.ruleForm.enclosure_url = '';
    },
  },
  async created() {
    this.Find();
    // 承保公司
    var cbgsList = await this.$globals.AxiosPost("company/SelectAll", {});
    this.cbgsList = cbgsList.data;  
    // 出险内容
    var cxList = await this.$globals.AxiosPost("/dictionaries/selectFind", {data_grouping: "insurance_type"});
    this.cxList = cxList.data; 
  },
}
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006E4B;
  border-color:  #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color:  #05573d;
  color:  #006E4B;
}
.el-button--goon {
  color: #FFF;
  background-color: #006E4B;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color:  #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color:  #006E4B;
  border-color:  #006E4B;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color:  #006E4B;
}
.el-checkbox__inner:hover{
  border-color:  #006E4B;
}

</style>


// WEBPACK FOOTER //
// Qtxzgl.vue?f2a8bb42